module.exports = __webpack_public_path__ + "static/img/mac.a993cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mac.png
// module id = WMFF
// module chunks = 36